import productApi from '@/api/api.product'
export default [
  {
    type: 'select',
    placeholder: '产品系列',
    filed: 'seriesId',
    default: '',
    query: productApi.series_select
  }
]
